export default __webpack_public_path__ + "static/media/discoverBooks.30ed85b8.png";